<div class="bb-slide" [ngClass]="item.class">
    <div class="bb-slide-image">
        <vn-image [src]="item.image.src" [alt]="item.image.alt" [width]="item.image.width" [height]="item.image.height" />
    </div>
    <div class="bb-slide-text">{{ item.text }}</div>
    <div class="bb-slide-amount">{{ balance | vnCurrency }}</div>
    @if (isNumber()) {
        <div class="bb-slide-amount">{{ text }}{{ balanceTourneyToken | number: '1.2-2' }}</div>
    }
</div>
